<template>
  <div
    :class="[wrapperStyle.class]"
    :style="[wrapperStyle.style]"
  >
    <div
      class="card"
      :id="tagId"
      :class="[cardStyle.class, 'group-field']"
      :style="[cardStyle.style]"
    >
      <div class="card-content" v-if="hasDefaults" :id="`${tagId}_content`">
        <div class="card-title" v-if="titleText">
          {{ titleText }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GroupField",
  props: {
    name: {
      type: String,
      required: true,
    },
    fieldType: {
      type: String,
      required: true,
    },
    tagId: {
      type: String,
      required: true,
    },
    titleText: {
      type: String,
      default: "",
    },
    cardStyle: {
      type: Object,
      default: () => ({}),
    },
    wrapperStyle: {
      type: Object,
      default: () => ({}),
    },
    hasDefaults: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  mounted() {
  },
  computed: {},
  methods: {},
};
</script>
<style scoped lang="scss">
.card {
  .card-content {
    .card-title {
      font-size: 20px;
    }
    .col {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
}
</style>
<style lang="scss">
.group-field {
  &.card {
    .card-content {
      padding: 16px;
      .col {
        padding: 0px;
     
        label {
          left: 10px;
        }
        &.input-field {
          margin-top: 0px;
          margin-bottom: 16px;
          &:last-child {
              margin-bottom: 0px !important;
          }
        }
      }
    }
  }
}
</style>
